<template>
  <div class="waypoint-navigator-track">
    <div class="waypoint-navigator-track__line" :class="isActiveClass"></div>
    <div v-for="waypoint in trackWaypoints"  :key="waypoint.id">
      <div class="waypoint-navigator-track__waypoint" :style="waypointStyle(waypoint)" @click.stop="onSelectWaypoint(waypoint)"></div>
    </div>
    <div v-for="scene in trackScenes" :key="scene.id" class="waypoint-navigator-track__scene" :style="sceneStyle(scene)"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'waypointNavigatorTrack',

  props: {
    tag: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  computed: {
    ...mapState(['keyFrame']),
    ...mapGetters(['videoDuration', 'currentTime', 'getAllWaypointsByTagId']),

    isActiveInKeyFrame: function () {
      const isActiveInKeyFrame = this.tag.scenes.some(scene => {
        return scene.waypoints.some(wp => {
          return wp.time.toFixed(2) === this.currentTime.toFixed(2)
        })
      })

      return isActiveInKeyFrame
    },

    isActiveClass: function () {
      return  {
        'is-active': this.isActiveInKeyFrame
      }
    },

    trackWaypoints: function () {
      const trackWaypoints = this.getAllWaypointsByTagId(this.tag.id) || []

      return trackWaypoints
    },

    trackScenes: function () {
      return this.tag.scenes ? this.tag.scenes : []
    },

    trackColor: function () {
      return this.isActiveInKeyFrame ? 'white' : '#eaab04'
    }
  },

  methods: {
    isWaypointSelected: function (waypoint) {
      return this.keyFrame.selectedWaypoints.some(swp => {
        return swp.wp === waypoint.wp
      })
    },

    waypointStyle: function (waypoint) {
      let leftPercentage = waypoint.time / this.videoDuration

      if (this.isWaypointSelected(waypoint)) {
        return {
          backgroundColor: 'red',
          left: `${leftPercentage * 100}%`,
          height: '14px',
          width: '14px',
          marginTop: '-7px',
          marginLeft: '-7px',
          zIndex: '1001'
        }
      } else {
        return {
          backgroundColor: this.trackColor,
          left: `${leftPercentage * 100}%`,
        }
      }
    },

    sceneStyle: function (scene) {
      const waypoints = [...scene.waypoints].sort((a,b) => a.time - b.time)

      let leftPercentage = waypoints[0].time / this.videoDuration
      let widthPercentage = (waypoints[waypoints.length - 1].time - waypoints[0].time) / this.videoDuration

      return {
        backgroundColor: this.trackColor,
        left: `${leftPercentage * 100}%`,
        width: `${widthPercentage * 100}%`
      }
    },

    onSelectWaypoint: function (waypoint) {
      this.$emit('selectWaypoint', waypoint)
    }
  }
}
</script>